import categoryDefaultImage from "./images/upload-default-image.png";

export default {
  images: {
    CATEGORY_DEFAULT_IMAGE: categoryDefaultImage,
  },
};
